import i18n from 'i18next';
import { registerValidator } from 'core/forms';

const isRequiredIfVisible = ({ condition, fieldValue }) => {
  const isRequired = !condition?.shouldHideField;

  return {
    error: i18n.t('error-required-field-error'),
    hasError: isRequired && !fieldValue,
    isRequired,
  };
};

registerValidator('isRequiredIfVisible', isRequiredIfVisible);

export default isRequiredIfVisible;
